import { render, staticRenderFns } from "./FormRatingShowValue.vue?vue&type=template&id=b4da706e&"
import script from "./FormRatingShowValue.vue?vue&type=script&lang=js&"
export * from "./FormRatingShowValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports